"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toJson = toJson;
exports.toPrettyJson = toPrettyJson;
function toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}
